import React from 'react'
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel'
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel'
import { ColumnFilterDefinitions, columnFilterSummary, isColumnFilterActive } from './ColumnFilterTypes'

interface Props {
    /** Ekranın bütün kolonları (gizlenmiş kolondaki filtre de görünsün diye). */
    columns: ColumnChooserModel[]
    definitions: ColumnFilterDefinitions
    filters: ColumnFilterModel[] | undefined
    onChange: (filters: ColumnFilterModel[]) => void
}

/**
 * Uygulanan kolon filtrelerinin tablonun üstündeki özeti. Şerit her zaman aynı
 * yerde ve aynı yükseklikte durur (filtre eklenip kaldırıldıkça tablo zıplamaz).
 * Filtre girilince etiketler "Kolon filtreleri"nin yanında belirir; her etiket ×
 * ile tek tek, "Tümünü temizle" ile hepsi birden kaldırılır. Etiketler şeride
 * sığmazsa kendi içinde yana kayar, "Tümünü temizle" hep görünür kalır.
 */
const ColumnFilterChips = ({ columns, definitions, filters, onChange }: Props) => {
    const active = (filters ?? []).filter(isColumnFilterActive)

    return (
        <div className='kf-chips'>
            <span className='kf-chips-label'>
                <i className='fa fa-filter'></i> Kolon filtreleri:
            </span>

            <div className='kf-chips-list'>
                {
                    active.length == 0 && (
                        <span className='kf-chips-hint'>Yok — başlıkların altındaki alanlardan süzebilirsiniz.</span>
                    )
                }
                {
                    active.map(f => {
                        const title = columns.find(c => c.name == f.column)?.title ?? f.column

                        return (
                            <span key={f.column} className='kf-chip'>
                                <b>{title}:</b>&nbsp;{columnFilterSummary(definitions[f.column]?.type, f)}
                                <button
                                    type='button'
                                    title={title + ' filtresini kaldır'}
                                    onClick={() => onChange(active.filter(x => x.column != f.column))}
                                >×</button>
                            </span>
                        )
                    })
                }
            </div>

            {
                active.length > 0 && (
                    <button type='button' className='kf-clear-all' onClick={() => onChange([])}>
                        Tümünü temizle ({active.length})
                    </button>
                )
            }
        </div>
    )
}

export default ColumnFilterChips
